import styled from 'styled-components'
import WarningIcon from 'components/WarningIcon'
import IconCaretSelect from 'components/IconCaretSelect'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 29.688rem;
`

export const Icon = styled(WarningIcon).attrs({
  dataTestId: 'add-user-modal-error-warning-icon',
})`
  margin-top: 2.45rem;
  margin-left: 12.625rem;
  margin-bottom: 1.35rem;
`

export const Title = styled.h2`
  text-align: center;
  font-size: 1.625rem;
  padding-left: 4.125rem;
  padding-right: 4.063rem;
  margin-bottom: 0.8rem;
  font-family: SharpSlab-Extrabold;
  color: #002855;
`

export const MainParagraph = styled.p`
  color: #555555;
  text-align: center;
  font-size: 1.25rem;
  line-height: 24px;
  font-family: Molde-medium;
  letter-spacing: 0;
  margin-bottom: 0.25rem;
`

export const SecondaryParagraph = styled.p`
  color: #555555;
  text-align: center;
  line-height: 24px;
  letter-spacing: 0;
`

export const ErrorParagraph = styled.p`
  color: #555555;
  text-align: center;
  line-height: 24px;
  letter-spacing: 0;
  padding-left: 5.875rem;
  padding-right: 5.813rem;
`

export const CloseButton = styled.button`
  font-size: 1rem;
  margin-top: 2rem;
  font-family: Molde-regular;
  margin-left: 11.375rem;
  margin-bottom: 1.22rem;
  width: 6.875rem;
  color: #ffffff;
  background-color: #3c6e90;
  border-color: #3c6e90;
  &:not([disabled]):hover {
    background-color: #002855;
    border-color: #002855;
  }
`

interface LinkWrapperProps {
  showingDetails?: boolean
}

export const LinkWrapper = styled.div<LinkWrapperProps>`
  display: flex;
  margin-bottom: ${({ showingDetails }) => (showingDetails ? '0' : '1.3rem')};
  margin-left: 11.25rem;
  align-items: center;
  cursor: pointer;
  width: fit-content;
`

export const Link = styled.a`
  color: #3c6e90 !important;
  padding-left: 0.438rem;
  width: fit-content;
  ${LinkWrapper}:hover & {
    color: #e1523d !important;
    text-decoration: none;
  }
`

interface IconCaretProps {
  showingDetails?: boolean
}

export const IconCaret = styled(IconCaretSelect)<IconCaretProps>`
  color: #3c6e90;
  transform: ${({ showingDetails }) =>
    showingDetails ? 'rotate(180deg)' : 'none'};
  ${LinkWrapper}:hover & {
    color: #e1523d;
  }
`

export const ErrorDetailWrapper = styled.div`
  margin-top: 0.85rem;
  margin-bottom: 1.36rem;
`
